import { CardMedia } from '@mui/material';
import ddmLoadingGif from '@/assets/images/logo/ddm_loading.gif';

export default function BounceSoupBallList({ count = 6 }: { count?: number }) {
    return (
        <div className="flex items-center justify-center">
            <img src={ddmLoadingGif} alt="Loading..." style={{ width: '120px', height: '120px' }} />
        </div>
    );
}
